'use strict';
var Log = require('utils/log');

var SimplePluginView = Marionette.ItemView.extend({
    initialize: function (options) {
        Log.assert(options.plugin != undefined);
        this.plugin = options.plugin;
    },

    getTemplate: function () {
        return Handlebars.compile(this.plugin.template);
    },

    serializeData: function () {
        return this.plugin.getTemplateData(this.options);
    },
});

var PluginViews = {
    simple: SimplePluginView,
};

var initializeAndShowPlugin = function (view, page, region, options) {
    Log.assert(typeof view === 'object');
    Log.assert(typeof view.showChildView === 'function');
    // assert that there is either a valid plugin or none at all
    Log.assert(
        !window.SDE_plugins ||
            !window.SDE_plugins[page] ||
            !window.SDE_plugins[page].type ||
            PluginViews[window.SDE_plugins[page].type] != undefined
    );

    if (
        !window.SDE_plugins ||
        !window.SDE_plugins[page] ||
        !window.SDE_plugins[page].type ||
        !view ||
        typeof view.showChildView != 'function'
    ) {
        // do nothing
        return;
    }

    options.plugin = window.SDE_plugins[page];
    view.showChildView(region, new PluginViews[options.plugin.type](options));
};

module.exports = initializeAndShowPlugin;
